import { useTenant } from '@emerald-works-nova/auth'
import React, { useEffect } from 'react'
import PrivateRoute from '../private-route'
import AuthorizeFeature from '../user-feature-guard/authorize-feature'

export const ToolkitPrivateRoute = ({
  scrollToTop = true,
  featureGuard,
  element,
  allowedUserGroups,
  publicOnlyForPublicTenant,
  ...rest
}) => {
  const tenant = useTenant()

  useEffect(() => {
    if (scrollToTop) {
      window.scrollTo(0, 0)
    }
  }, [scrollToTop])

  if (tenant.isPublicTenant && publicOnlyForPublicTenant) {
    return React.cloneElement(element, rest)
  }

  const component = featureGuard
    ? <AuthorizeFeature feature={featureGuard} component={element} />
    : element

  return (
    <PrivateRoute element={component} allowedUserGroups={allowedUserGroups} {...rest} />
  )
}
